import { useTranslation } from "next-i18next";
import React from "react";

import styles from "./gift-card-image-grid-header.module.scss";

const GiftCardImageGridHeader: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <h4 className={styles.heading}>{t("giftCards.header.heading")}</h4>
            <p className={styles.content}>{t("giftCards.header.content")}</p>
        </>
    );
};

export default GiftCardImageGridHeader;
